"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CartItemOptions = /** @class */ (function (_super) {
    __extends(CartItemOptions, _super);
    function CartItemOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartItemOptions.prototype.render = function () {
        var lineitem = this.props.lineitem;
        return lineitem.options_with_values ? (React.createElement("div", { className: "" + (this.props.className ? this.props.className : "") }, lineitem.options_with_values
            .filter(function (option) { return !option.name.toLowerCase().includes("color"); })
            .filter(function (option) { return !option.name.toLowerCase().includes("colour"); })
            .filter(function (option) { return !option.name.toLowerCase().includes("type"); })
            .filter(function (option) { return !option.name.toLowerCase().includes("value"); })
            .map(function (option, i) { return (React.createElement("span", { key: i, className: "block mt-0-2" }, option.name.toLowerCase().includes("size") ? option.value : "ONE SIZE")); }))) : null;
    };
    return CartItemOptions;
}(React.PureComponent));
exports.CartItemOptions = CartItemOptions;
